export async function getBlob(url: string): Promise<Blob> {
  const blob = await fetch(url).then(p => p.blob());

  return blob;
}
